// palette used for charts
import palette from 'shared/theme/vars/palette'

export default {
  ...palette,
  '@gray': '#bbb'
}
